import { sortFunction } from "us.common/components/MainSearch/Functions";
import {
  ICreditorSearchResult,
} from "us.common/reducers/MainSearch/Interfaces";
import { ITab } from "../Interfaces";

/**
 * @function
 * @description To get the creditor search results sorted
 * @param creditorDetails Filtered Creditor search results
 * @param tabInfo Formik tab information
 * @returns sorted input
 */
export const getCreditorValSorted = (
  creditorDetails: ICreditorSearchResult[],
  {
    sortKey,
    sortOrder,
  }: ITab<ICreditorSearchResult>
) => {
  try {
    if(Array.isArray(creditorDetails)){
      return creditorDetails.sort((value1, value2) =>
        sortFunction(
          value1[sortKey as keyof ICreditorSearchResult],
          value2[sortKey as keyof ICreditorSearchResult],
          sortOrder
        )
      )
    }else{
      return []
    }
  } catch (e) {
    return [];
  }
};
